/**
 * 微信小程序「URL Link」完整 https 地址（在微信公众平台 / 开放平台为对应小程序生成）。
 * 填后互动页会显示「打开微信小程序」按钮；留空则仅展示文字说明。
 */
export const WECHAT_MINI_OPENLINK_MUSIC_LINES = (
  import.meta.env.VITE_WECHAT_MINI_OPENLINK_MUSIC_LINES as string | undefined
)
  ?.trim() ?? "";

/**
 * 古典名画对对配小程序的 URL Link（同上）。
 */
export const WECHAT_MINI_OPENLINK_PAINTING_MATCH = (
  import.meta.env.VITE_WECHAT_MINI_OPENLINK_PAINTING_MATCH as string | undefined
)
  ?.trim() ?? "";

/**
 * 诗词飞花对对配小程序的 URL Link（同上）。
 */
export const WECHAT_MINI_OPENLINK_POETRY = (
  import.meta.env.VITE_WECHAT_MINI_OPENLINK_POETRY as string | undefined
)
  ?.trim() ?? "";

export const BRAND_TITLE = "尚诺艾 SANOI";
